import * as ACTION_TYPES from "../actions/action-types";

const initialState = {
  shouldRefreshForms: false,
};

/**
 * Workflow reducer to handle workflow-related actions
 * @author Muskan Thakur
 */
const workflow = (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case ACTION_TYPES.REFRESH_WORKFLOW_FORMS:
      return {
        ...state,
        shouldRefreshForms: true,
      };

    case ACTION_TYPES.RESET_REFRESH_WORKFLOW_FORMS:
      return {
        ...state,
        shouldRefreshForms: false,
      };

    default:
      return state;
  }
};

export default workflow;
